import { useCallback } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { configureArkPes, fetchArkPesConfig } from '../../../services/queries/MaggieIntegrationsQueries';
import { ArkPesFormValues } from './arkPesConfig.schema';

export function useArkPesConfigActions() {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ['arkpes-config'],
    queryFn: fetchArkPesConfig,
  });

  const mutation = useMutation({
    mutationFn: configureArkPes,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['arkpes-config'] });
      queryClient.invalidateQueries({ queryKey: ['integrations'] });
    },
  });

  const config = data ?? null;
  const isConnected = config?.isConnected ?? false;

  const saveConfig = useCallback(
    async (values: ArkPesFormValues) => {
      const result = await mutation.mutateAsync({
        clientId: values.clientId.trim(),
      });
      return result;
    },
    [mutation]
  );

  const resetConfig = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ['arkpes-config'] });
  }, [queryClient]);

  return { config, isConnected, isLoading, saveConfig, resetConfig };
}
